import * as React from "react";
const SvgCapillary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 22 16"
    {...props}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="url(#Capillary_logo_svg__a)"
        d="M10.97 2.042c.371.256.858.597 1.252.904C17.361.273 20.62 4.703 17.434 7.55a7.195 7.195 0 0 1-1.348.917c-1.62.91-4.025 2.162-4.574 4.129-.287 1.032.032 2.254.898 2.9a2.757 2.757 0 0 0 2.284.418c2.954-.614 3.77-3.736 2.888-6.18l-.024.014c.428-.267.839-.56 1.23-.877 7.035-5.75.264-12.214-7.816-6.828Zm5.048 8.58c.285 2.867-2.71 4.472-3.851 3.618-1.142-.854 1.686-2.468 3.168-3.255l.683-.364Z"
      />
      <path
        fill="url(#Capillary_logo_svg__b)"
        d="M15.728 2.146V.112C14.274.32 12.65.927 10.97 2.045c.37.257.857.598 1.252.905 1.317-.69 2.51-.908 3.505-.804Z"
      />
      <path
        fill="url(#Capillary_logo_svg__c)"
        d="m17.585 9.73-1.566.892c.045.433.011.87-.1 1.292v3.538c1.922-1.1 2.436-3.64 1.666-5.723Z"
      />
      <path
        fill="url(#Capillary_logo_svg__d)"
        d="M12.429 3.106c-.473-.368-.927-.757-1.425-1.09C2.518-3.693-4.58 3.941 4.52 9.788a11.94 11.94 0 0 1 .81-1.72C.916 5.354 4.375.085 9.792 2.948c.38.18 4.632 2.687 5.715 5.849.441-.247.899-.484 1.339-.783-.84-1.508-2.61-3.451-4.418-4.908Z"
      />
      <path
        fill="url(#Capillary_logo_svg__e)"
        d="M14.682 5.193c-.059.061-.116.12-.182.176a3.923 3.923 0 0 1-.262.202c-.09.064-.184.127-.28.188l-.279.183-.014.009a8.127 8.127 0 0 1 1.844 2.838c.441-.247.899-.484 1.339-.783a15.429 15.429 0 0 0-2.166-2.813Z"
      />
      <path
        fill="url(#Capillary_logo_svg__f)"
        d="M3.443 5.856c-.175.153-.362.29-.56.412-.2.125-.406.24-.61.357-.103.057-.205.114-.305.177l-.15.09c-.05.029-.101.059-.151.091-.05.032-.124.087-.182.129a11.767 11.767 0 0 0 3.03 2.677c.224-.594.495-1.17.811-1.721-1.04-.64-1.64-1.425-1.883-2.212Z"
      />
      <path
        fill="url(#Capillary_logo_svg__g)"
        d="M3.443 5.856c-.175.153-.362.29-.56.412-.2.125-.406.24-.61.357-.103.057-.205.114-.305.177l-.15.09c-.05.029-.101.059-.151.091-.05.032-.124.087-.182.129a11.767 11.767 0 0 0 3.03 2.677c.224-.594.495-1.17.811-1.721-1.04-.64-1.64-1.425-1.883-2.212Z"
      />
      <path
        fill="url(#Capillary_logo_svg__h)"
        d="M6.691 8.83c.034-.072.068-.144.102-.211.83-1.702 2.582-3.614 4.253-4.886l-.326-.23a7.33 7.33 0 0 0-.898-.537A22.123 22.123 0 0 0 6.514 6.28c-1.092 1.413-2.432 3.212-2.432 5.547 0 1.88.99 3.615 3.242 4.082a2.932 2.932 0 0 0 2.359-.419c.42-.342.73-.8.89-1.315a2.72 2.72 0 0 0 .008-1.584C9.966 10.569 6.69 8.83 6.69 8.83Zm3.25 5.332c-.94.976-3.758-.386-3.928-2.771-.02-.244 0-.49.057-.728.475.231 4.935 2.38 3.87 3.494v.005Z"
      />
      <path
        fill="url(#Capillary_logo_svg__i)"
        d="M7.624 5.247c.148.113.297.224.447.333.151.11.304.215.458.317.037.025.076.048.116.072a17.453 17.453 0 0 1 2.401-2.239l-.326-.23a7.33 7.33 0 0 0-.898-.537 23.933 23.933 0 0 0-2.327 2.18c.043.035.085.07.13.104Z"
      />
      <path
        fill="url(#Capillary_logo_svg__j)"
        d="M6.692 8.83c-.266.59-.474 1.205-.622 1.835.952.453 1.866.977 2.736 1.57h1.633C9.587 10.367 6.692 8.83 6.692 8.83Z"
      />
      <path
        fill="url(#Capillary_logo_svg__k)"
        d="M6.692 8.83c-.266.59-.474 1.205-.622 1.835.952.453 1.866.977 2.736 1.57h1.633C9.587 10.367 6.692 8.83 6.692 8.83Z"
      />
    </g>
    <defs>
      <linearGradient
        id="Capillary_logo_svg__a"
        x1={18.513}
        x2={6.939}
        y1={-3.924}
        y2={13.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F05A24" />
        <stop offset={0.2} stopColor="#F05D24" />
        <stop offset={0.32} stopColor="#F58E16" />
        <stop offset={0.52} stopColor="#FDDB00" />
        <stop offset={0.55} stopColor="#EAD707" />
        <stop offset={0.65} stopColor="#AACA1F" />
        <stop offset={0.75} stopColor="#78C031" />
        <stop offset={0.83} stopColor="#54B83F" />
        <stop offset={0.9} stopColor="#3EB447" />
        <stop offset={0.94} stopColor="#36B24A" />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__b"
        x1={11.822}
        x2={13.133}
        y1={3.421}
        y2={0.215}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF4F27" />
        <stop offset={0.32} stopColor="#D95226" stopOpacity={0.69} />
        <stop offset={1} stopColor="#F05A24" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__c"
        x1={15.657}
        x2={16.948}
        y1={10.508}
        y2={10.81}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#76933C" />
        <stop offset={1} stopColor="#2E9C48" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__d"
        x1={4.779}
        x2={6.72}
        y1={-1.576}
        y2={10.253}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1687C8" />
        <stop offset={0.29} stopColor="#1687C8" />
        <stop offset={0.3} stopColor="#1688C7" />
        <stop offset={0.46} stopColor="#22979A" />
        <stop offset={0.61} stopColor="#2AA377" />
        <stop offset={0.76} stopColor="#31AB5E" />
        <stop offset={0.89} stopColor="#35B04F" />
        <stop offset={1} stopColor="#36B24A" />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__e"
        x1={14.83}
        x2={16.766}
        y1={6.351}
        y2={8.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36B24A" stopOpacity={0} />
        <stop offset={0.14} stopColor="#2DAF4A" stopOpacity={0.212} />
        <stop offset={0.46} stopColor="#1AA84A" stopOpacity={0.631} />
        <stop offset={0.68} stopColor="#0EA44A" stopOpacity={0.898} />
        <stop offset={0.8} stopColor="#09A24A" />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__f"
        x1={6.52}
        x2={1.377}
        y1={9.38}
        y2={6.377}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#0EAB4B" />
        <stop offset={0.39} stopColor="#10A366" stopOpacity={0.78} />
        <stop offset={0.67} stopColor="#148FAB" stopOpacity={0.231} />
        <stop offset={0.78} stopColor="#1687C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__g"
        x1={6.52}
        x2={1.377}
        y1={9.38}
        y2={6.377}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#038A45" />
        <stop offset={0.41} stopColor="#088968" stopOpacity={0.729} />
        <stop offset={0.76} stopColor="#1587C2" stopOpacity={0.051} />
        <stop offset={0.78} stopColor="#1687C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__h"
        x1={11.597}
        x2={3.339}
        y1={16.923}
        y2={11.892}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDDB00" />
        <stop offset={0.34} stopColor="#FDD901" />
        <stop offset={0.52} stopColor="#FCD104" />
        <stop offset={0.67} stopColor="#FAC308" />
        <stop offset={0.79} stopColor="#F8B00F" />
        <stop offset={0.9} stopColor="#F69818" />
        <stop offset={0.98} stopColor="#F38020" />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__i"
        x1={10.205}
        x2={9.156}
        y1={3.155}
        y2={5.161}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF4F27" />
        <stop offset={0.18} stopColor="#D75226" stopOpacity={0.749} />
        <stop offset={0.38} stopColor="#E05525" stopOpacity={0.478} />
        <stop offset={0.58} stopColor="#E75725" stopOpacity={0.271} />
        <stop offset={0.75} stopColor="#EC5924" stopOpacity={0.122} />
        <stop offset={0.9} stopColor="#EF5A24" stopOpacity={0.031} />
        <stop offset={1} stopColor="#F05A24" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__j"
        x1={6.271}
        x2={8.435}
        y1={9.392}
        y2={12.657}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#67BB46" />
        <stop offset={0.38} stopColor="#A9D033" />
        <stop offset={0.56} stopColor="#CBDB2A" />
        <stop offset={0.71} stopColor="#D8D91F" />
        <stop offset={0.98} stopColor="#FAD502" />
        <stop offset={1} stopColor="#FDD500" />
      </linearGradient>
      <linearGradient
        id="Capillary_logo_svg__k"
        x1={6.271}
        x2={8.435}
        y1={9.392}
        y2={12.657}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#029347" />
        <stop offset={0.17} stopColor="#3DA83E" stopOpacity={0.698} />
        <stop offset={0.34} stopColor="#70BA37" stopOpacity={0.451} />
        <stop offset={0.51} stopColor="#98C931" stopOpacity={0.251} />
        <stop offset={0.67} stopColor="#B4D32D" stopOpacity={0.11} />
        <stop offset={0.84} stopColor="#C5D92B" stopOpacity={0.031} />
        <stop offset={1} stopColor="#CBDB2A" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCapillary;
